<template>
  <b-card no-body>
    <b-card-header>
      <b-row>
        <b-col md="6">
          <h3 class="mb-0" v-if="currentPlan">
            Subscription:
            {{ currentPlan[0].name }} - 
            <span v-if="currentPlan[0].monthly_price.id == subscription">{{ currentPlan[0].monthly_price.price / 100 | currency }}/Month</span>
            <span v-if="currentPlan[0].yearly_price.id == subscription">{{ currentPlan[0].yearly_price.price / 100 | currency }}/Year</span>
          </h3>
        </b-col>
        <b-col md="6">
          <b-button-group size="sm" class="float-right">
            <b-button variant="danger" href="/account/your-account">Cancel Subscription</b-button>
            <b-button variant="success" v-if="upgradeable" v-b-modal.subscription-upgrade>Upgrade</b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-card-header>
    <div class="card-body">
      <strong>Invoices:</strong>
    </div>

    <b-table responsive id="invoices" small :items="invoices" :fields="fields" v-if="invoices">
      <template #cell(actions)="row">
        <a :href="'/account/invoice/' + row.item.id" class="btn btn-sm btn-primary" target="_blank">Download</a>
      </template>
    </b-table>
    <loading-panel v-else></loading-panel>

    <subscription-upgrade :plans="plans" @upgrade="upgrade"></subscription-upgrade>
  </b-card>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import LoadingPanel from '@/components/LoadingPanel';
import SubscriptionUpgrade from './SubscriptionUpgrade';

export default {
  mixins: [errorsMixin],
  components: {
    LoadingPanel,
    SubscriptionUpgrade
  },
  data: function() {
    return {
      subscription: '',
      invoices: null,
      fields: [
        {
          key: 'id',
          label: 'ID'
        },
        {
          key: 'date'
        },
        {
          key: 'total'
        },
        {
          key: 'actions',
          label: ''
        }
      ],
      loading_invoices: true,
      plans: null
    }
  },
  computed: {
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    upgradeable() {
      return (this.currentPlan && this.currentPlan[0]) ? this.currentPlan[0].name == 'Leading Yourself' || this.currentPlan[0].name == 'Leading Others' : false;
    },
    currentPlan() {
      return this.plans ? this.plans.filter((plan) => {
        return plan.monthly_price.id == this.subscription || plan.yearly_price.id == this.subscription;
      }) : null;
    }
  },
  methods: {
    async getSubscriptions() {
      axios.get(this.userRoute + '/subscriptions')
        .then(response => {
          this.plans = response.data;
        })
        .catch(error => {
          this.error(error);
        });
    },
    async getSubscription() {
      axios.get(this.userRoute + "/subscription")
        .then(response => {
          this.subscription = response.data.id;
        })
        .catch(error => {
          this.error(error);
        });
    },
    async getInvoices() {
      axios.get(this.userRoute + "/invoices")
        .then(response => {
          this.loading_invoices = false;
          this.invoices = response.data;
        })
        .catch(error => {
          this.error(error);
        });
    },
    async upgrade(plan) {
      axios.post(this.userRoute + "/subscription/upgrade", {
        stripe_plan: plan
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
        this.getSubscription();
        this.$bvModal.hide('subscription-upgrade');
      })
      .catch(error => {
        this.error(error);
      });
    }
  },
  created() {
    this.getSubscriptions();
    this.getSubscription();
    this.getInvoices();
  },
};
</script>